import { ApiRef, createApiRef } from "@backstage/core-plugin-api";
import { PlatformVersionServiceEntry } from "@internal/plugin-platform-version-common";

export const platformServiceVersionApiRef: ApiRef<PlatformServiceVersionApi> = createApiRef<PlatformServiceVersionApi>(
    {
        id: "plugin.platformversion.service",
    }
);

export interface PlatformServiceVersionApi {
    loadByComponentName: (id: String) => Promise<PlatformVersionServiceEntry>;
    loadForAllServices: () => Promise<PlatformVersionServiceEntry[]>;
}